<template>
    <div class="field">
        <label 
            class="label pops-out"
            :class="{'popped-out': inputRequired}"
            :for="id"
        >{{ placeholderText }}</label>
        <div class="control">
            <input
                v-if="type !== 'textarea'"
                class="input is-rounded"
                :class="{'is-danger': inputDirty & !(inputRequired & inputExtra)}"
                :id="id"
                :type="type"
                :placeholder="placeholderText"
                v-model="inputValue"
                v-bind="$attrs"
            >
            <textarea
                v-else
                class="textarea is-rounded"
                :class="{'is-danger': inputDirty & !(inputRequired & inputExtra)}"
                :id="id"
                :placeholder="placeholderText"
                v-model="inputValue"
                v-bind="$attrs"
                autocomplete="off"
            ></textarea>
        </div>
        <p
            class="help is-danger"
            v-if="inputDirty & !inputRequired"
        >This field is required</p>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            inputDirty: Boolean,
            inputExtra: {
                default: true,
                type: Boolean
            },
            inputRequired: Boolean,
            placeholderText: String,
            type: String,
            value: {
                type: String,
                required: true
            },
            reset: Boolean
        },
        inheritAttrs: false,
        data() {
            return {
                inputValue: this.value
            }
        },
        watch: {
            inputValue(val) {
                this.$emit('input', val);
            },
            reset() {
                this.inputValue = '';
            }
        }
    }
</script>

<style lang="scss">
    .pops-out {
        max-height: 0;
        transition: max-height .2s ease;
        margin-bottom: 0 !important;
        padding-left: calc(calc(0.75em - 1px) + 0.375em);
    }

    .popped-out {
        max-height: 1.5rem;
    }

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px white inset;
    }
</style>